import React, { useEffect, useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import './LoginContent.css';
import { connect } from 'react-redux';
import LoginHeaderSelector from '../selectors/LoginHeader';
import FormWrapper from 'components/FormWrapper';
import videos from 'data/videos';
import OldBrowserWarning from 'components/OldBrowserWarning';
import queryString from 'query-string'
import JWPlayer from '@jwplayer/jwplayer-react';
import { useLocation } from 'react-router-dom';

const LogInContent = (props) => {
    const location = useLocation();

    const [hasUserSignedOut, setHasUserSignedOut] = useState(false);
    const [showVideo, setShowVideo] = useState(false);

    useEffect(() => {
        const values = queryString.parse(location.search);
        if (location.search != null && values.signed_out != undefined)
            setHasUserSignedOut(true);
        else
            setHasUserSignedOut(false);
    }, [location.search]);

    const showVideoHandler = (event) => {
        event.preventDefault();
        setShowVideo(true);
    };

    const messages = defineMessages({
        signed_out: {
            id: 'signed_out',
            description: 'You have successfully signed out.',
            defaultMessage: 'You have successfully signed out.'
        },
        quick_start_guide: {
            id: 'quick_start_guide',
            description: 'quick_start_guide',
            defaultMessage: 'Click Here for a Quick Video Training Guide'
        }
    });

    if (!showVideo)
        return <div>
            <FormWrapper key='loginErrorMessage' id="loginErrorMessage" {...props}
                formErrors={props.genericErrorMessage} />

            <div className="login-header-new-video text-center" onClick={showVideoHandler}>
                <i className="fa fa-youtube-play login-header-new-video-icon" aria-hidden="true"></i>
                <a className="login-header-new-video-link" href=""><FormattedMessage {...messages.quick_start_guide} /></a>
            </div>

            {hasUserSignedOut ?
                <div className="login-header-signed-out text-center">
                    <span><FormattedMessage {...messages.signed_out} /></span>
                </div>
                : undefined
            }

            <div css='width: 100%;'>
                <img src="/assets/PartnerConnect_LoginScreenBanner.jpg" className="img-responsive" css="width: inherit;" />
            </div>

        </div>

    return <div>
        <FormWrapper key='loginErrorMessage' id="loginErrorMessage" {...props}
            formErrors={props.genericErrorMessage} />


        <div className="login-header-new-video text-center">
                <i className="fa fa-youtube-play login-header-new-video-icon" aria-hidden="true"></i>
                <span className="login-header-new-video-link"><FormattedMessage {...messages.quick_start_guide} /></span>
                <span className="login-header-new-video-error"><OldBrowserWarning /></span>
        </div>

        {
            hasUserSignedOut ?
                <div className="login-header-signed-out text-center">
                    <span><FormattedMessage {...messages.signed_out} /></span>
                </div>
                : undefined
        }
        <JWPlayer
            file={props.selectedCountry == "MEX" ? videos.quick_start_mex.videoLocation : videos.quick_start.videoLocation}
            library={videos.playerLocation}
            id={props.selectedCountry == "MEX" ? "quick_start_mex" : "quick_start"}
            image={props.selectedCountry == "MEX" ? videos.quick_start_mex.imageLocation : videos.quick_start.imageLocation}
            autostart={"viewable"}
        />
    </div >;
};

export default connect(LoginHeaderSelector)(LogInContent);